import React, { useContext, useEffect, useState } from "react";
import useStyles from "./styles";
import { __t } from "@core/translation/translation";
import { Grid } from "@material-ui/core";
import { useParams } from "react-router-dom";
import walletsApi from "@api/wallets";
import { MarketContext } from "@context/MarketContext";
import { getMarketPairDisplay } from "@core/utils/getCurrencyMeta";
import FeePopover from "./FeePopover";
import CurrentMarketPrice from "../CurrentMarketPrice";
import LimitOrder from "../LimitOrder";

const DealComponent = ({ type }) => {
  const classes = useStyles();
  const [alignment, setAlignment] = useState("Limit_Order");
  const { currencyName } = useParams();
  const market = useContext(MarketContext);
  const { baseUnit, quoteUnit } = getMarketPairDisplay(currencyName);
  const [state, setState] = useState({
    SellInventory: 0,
    BuyInventory: 0,
  });

  useEffect(() => {
    walletsApi
      .getMyWalletByCurrency({
        params: {
          currencyName: quoteUnit,
        },
      })
      .then((data) => {
        setState((prevState) => ({
          ...prevState,
          BuyInventory: data.content.availableBalance,
        }));
      })
      .catch((data) => {});

    walletsApi
      .getMyWalletByCurrency({
        params: {
          currencyName: baseUnit,
        },
      })
      .then((data) => {
        setState((prevState) => ({
          ...prevState,
          SellInventory: data.content.availableBalance,
        }));
      })
      .catch((data) => {});
  }, [currencyName, market.forceUpdate, baseUnit, quoteUnit]);

  const handleAlignment = (event, newAlignment) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
    }
  };

  const checkAlignment = (alignment) => {
    if (alignment === "Limit_Order") {
      return <LimitOrder type={type} />;
    } else if (alignment === "Current_Market_Price") {
      return <CurrentMarketPrice type={type} />;
    }
  };
  return (
    <Grid
      container
      direction="column"
      className={classes.container}
      spacing={5}
    >
      <Grid item container>
        <FeePopover alignment={alignment} handleAlignment={handleAlignment} />
      </Grid>
      <Grid item>{checkAlignment(alignment)}</Grid>
    </Grid>
  );
};

export default DealComponent;
